import React from 'react';
import SumsubWebSdk from "@sumsub/websdk-react"
import { useEffect, useState } from 'react';
import loadgif from "../img/kyc/loading__.gif"
import { ShimmerSkeleton } from '../utils/SkimmerSkeleton';
import Pending from "../img/kycpending1.png"
import SuccessVerification from "../img/kyc/successVerification.png"
import InitialVerification from "../img/kyc/initialVerification.png"
import RejectedVerification from "../img/kyc/rejectedVerification.png"
import { ReactComponent as AssesRiskTick } from '../img/kyc/assesRiskTick.svg';
import { ReactComponent as Arrow } from '../img/kyc/assesArrow.svg';
import { ReactComponent as KycTick } from '../img/kyc/kycVerifiedTick.svg';
import Box from "@mui/material/Box";
import { Typography, Button } from '@mui/material';
import { ApiService } from '../API/AxiosInstance';
import { captureException } from '@sentry/react';
import { colors, PrimaryButton } from '../Theme';

export default function Sumsub({sumSubClicked, setSumSubClicked}) {
    const [accessToken, setAccessToken] = useState("");
    const [loading, setloading] = useState(false)
    const [isVerify, setIsVerify] = useState(false)
    let currentApplicantId = localStorage.getItem('applicantId')
    const [moderationComment, setModerationComment] = useState('')
    const [applicantId, setIsApplicantId] = useState(currentApplicantId)
    const [statuses, setStatuses] = useState([])
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ""

    useEffect(() => {
        (async () => {
            setloading(true)
            let userid = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ""
            await ApiService().post("kyc-verification/access-tokens", { userId: userid }).then(res => {
                setAccessToken(res.data.token)
                setloading(false)
            })
                .catch(error => {
                    setAccessToken("")
                    setloading(false)
                    captureException(error)
                })
        })()

    }, [])

    useEffect(() => {
        if(applicantId) {
            localStorage.setItem('applicantId',applicantId)
            setloading(true)
        } 
    },[applicantId])

    useEffect(() => {
        if(applicantId) {
            fetchData(userId)
        }
    },[applicantId])

    const fetchData = async (id) => {
            await ApiService().get(`kyc-verification/${id}`).then(res => {
                if(res?.data) {
                    setStatuses(res?.data?.userKycStatus)
                    setModerationComment(res?.data?.userKycStatus?.moderationComment)
                }
                setloading(false)
            })
                .catch(err => {
                    setloading(false)
                })
    };

    const handleSuccessClicked = () => {
        setSumSubClicked(true)
    }

    return (<Box sx={{ backgroundColor: colors.background.paper, width: '100%', height: "100%" }}>

        {loading ?
            (<Box sx={{ width: '100%', height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <ShimmerSkeleton  sx={{width:"100%", height:"54px",}} />
            </Box>)
            : ( (!currentApplicantId || isVerify) ? (
                 <div> {accessToken &&
                    <SumsubWebSdk
                        accessToken={accessToken}
                        expirationHandler={() => accessToken}
                        config={{
                            lang: "en-us",
                        }}
                        onMessage={(data, payload) => {
                            if(data == "idCheck.onApplicantLoaded") {
                                setIsApplicantId(payload.applicantId)
                            }
                        }}
                    />
                }</div>
            ) : (
                // (statuses) && ((statuses?.reviewAnswer == "GREEN" && statuses?.reviewStatus == "onHold" || statuses?.reviewStatus == "pending")) ? (
                    ((statuses?.status == "onHold" || statuses?.status == 'OnHold' || statuses?.status == 'Pending'  || statuses?.status == 'pending')) ? (
                    !sumSubClicked ? (<Button onClick={handleSuccessClicked}   sx={{display:"flex", width:"100%", height:{xs:'auto', sm:"78px"}, padding:'16px', backgroundColor:"#E99611", '&:hover':{
                        backgroundColor:"#E99611"
                      }}}>
                        
                        <Box sx={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <Box sx={{display:"flex", gap:"10px", width:"100%", alignItems:"center"}}>
                                <KycTick/>
                                <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                    <Typography  sx={{ textAlign:"left", fontWeight:"600", fontSize:"14px", color:colors.primary.contrastText, lineHeight:"22px"}}>KYC Under Review</Typography>
                                    <Typography  sx={{ fontWeight:"400", fontSize:"13px", color:colors.primary.contrastText, lineHeight:"19px"}}>Your KYC is under review</Typography>
                                </Box>                    
                            </Box>
                            <Box sx={{}}>
                                    <Arrow />
                            </Box>
                        </Box>
                      </Button>) : (
                            <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:colors.background.paper}}>
                            <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                                <Box 
                                sx={{alignItems:'center', alignSelf:'center', backgroundColor:colors.background.paper}}
                                component={'img'}
                                src={Pending}
                                height={'200px'}
                                width={'auto'}
                                />
                            
                            </Box>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                <Typography variant='h5_1' sx={{ color: '#001F3F', alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Under Review </Typography>
                                <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >Your KYC verification is under review, you will be notified once it is completed.</Typography>
                            </Box>
                            
                            <PrimaryButton onClick={() => setSumSubClicked(false)} sx={{fontWeight:"500", mt:4, fontSize: '15px', display:"flex", alignSelf:"center"}} >
                            Back
                            </PrimaryButton>
                            
                        </Box>
                      )
                    // ) : (statuses?.reviewAnswer == "GREEN" && (statuses?.reviewStatus == "completed") ? (
                    ) : (statuses?.status == "completed" || statuses?.status == "Completed" ? (
                        !sumSubClicked ? (<Button onClick={handleSuccessClicked} sx={{display:"flex", width:"100%", height:{xs:'auto', sm:"78px"}, p:'10px', backgroundColor:colors.secondary.main, '&:hover':{
                            backgroundColor:colors.secondary.main
                          }}}>
                            <Box sx={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                                <Box sx={{width:"100%",display:"flex", gap:"10px", width:"100%", alignItems:"center"}}>
                                    <KycTick/>
                                    <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                        <Typography  sx={{ textAlign:"left", fontWeight:"600", fontSize:"14px", color:colors.primary.contrastText, lineHeight:"22px"}}>KYC Verified!</Typography>
                                        <Typography  sx={{ fontWeight:"400", fontSize:"13px", color:colors.primary.contrastText, lineHeight:"19px"}}>Your KYC is verified!</Typography>
                                    </Box>  
                                </Box>   
                                <Box>
                                    <Arrow />
                                </Box>               
                                </Box>
                          </Button>): (
                              <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:colors.background.paper}}>
                                <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                                    <Box 
                                    sx={{alignItems:'center', alignSelf:'center', backgroundColor:colors.background.paper}}
                                    component={'img'}
                                    src={SuccessVerification}
                                    height={'200px'}
                                    width={'auto'}
                                    />
                                
                                </Box>
                                <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                    <Typography variant='h5_1' sx={{ color: '#001F3F', alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600', letterSpacing:"0.5%" }} >Verification Success! </Typography>
                                    <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} > Your KYC was approved.</Typography>
                                </Box>
                                <PrimaryButton onClick={() => setSumSubClicked(false)} sx={{fontWeight:"500", mt:4, fontSize: '15px', display:"flex", alignSelf:"center"}} >
                                Back
                                </PrimaryButton>
                            </Box>
                          )
                          
                    ) : (statuses?.status == "init" || statuses?.status == "Init" || statuses?.status == null  ? (
                       !sumSubClicked ? (<Button onClick={handleSuccessClicked}   sx={{display:"flex", width:"100%", height:{xs:'auto', sm:"78px"}, p:'10px', backgroundColor:colors.primary.main, '&:hover':{
                            backgroundColor:colors.primary.main
                          }}}>
                            
                            <Box sx={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                                <Box sx={{display:"flex", gap:"10px", width:"100%", alignItems:"center"}}>
                                    <AssesRiskTick/>
                                    <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                        <Typography  sx={{ textAlign:"left", fontWeight:"600", fontSize:"14px", color:colors.primary.contrastText, lineHeight:"22px"}}>Verify your KYC</Typography>
                                        <Typography  sx={{ fontWeight:"400", fontSize:"13px", color:colors.primary.contrastText, lineHeight:"19px"}}>Deposit, withdraw and trade</Typography>
                                    </Box>                    
                                </Box>
                                <Box >
                                        <Arrow />
                                    </Box>
                            </Box>
                          </Button>): (
                            <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:colors.background.paper}}>
                            <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                                <Box 
                                sx={{alignItems:'center', alignSelf:'center', backgroundColor:colors.background.paper}}
                                component={'img'}
                                src={InitialVerification}
                                height={'200px'}
                                width={'auto'}
                                />
                            
                            </Box>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                <Typography variant='h5_1' sx={{ color: '#001F3F', alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Verify your KYC! </Typography>
                                <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >Complete identity verification to access.</Typography>
                            </Box>
                            <PrimaryButton onClick={() => setIsVerify(true)} sx={{fontWeight:"500", mt:4, fontSize: '15px', display:"flex", alignSelf:"center"}} >
                            Verify Now
                            </PrimaryButton>
                            <PrimaryButton onClick={() => setSumSubClicked(false)} sx={{fontWeight:"500", fontSize: '15px', display:"flex", alignSelf:"center"}} >
                            Back
                            </PrimaryButton>
                        </Box>
                          )
                    // ) : ((statuses?.reviewAnswer == "init" || statuses?.reviewStatus == "RED") &&
                ) : ((statuses?.status == "RED" || statuses?.status == "temporary_rejection" || statuses?.status == "final_rejection") &&
                  <> {!sumSubClicked ? (<Button onClick={handleSuccessClicked}   sx={{display:"flex", width:"100%", height:{xs:'auto', sm:"78px"}, p:'10px', backgroundColor:colors.error.main, '&:hover':{
                        backgroundColor:colors.error.main
                      }}}>
                        
                        <Box sx={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <Box sx={{display:"flex", gap:"10px", width:"100%", alignItems:"center"}}>
                                <KycTick/>
                                <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                    <Typography  sx={{ textAlign:"left", fontWeight:"600", fontSize:"14px", color:colors.primary.contrastText, lineHeight:"22px"}}>KYC Declined</Typography>
                                    { statuses?.status != "final_rejection" && <Typography  sx={{ fontWeight:"400", fontSize:"13px", color:colors.primary.contrastText, lineHeight:"19px"}}>Please submit again.</Typography>}
                                </Box>                    
                            </Box>
                            <Box >
                                    <Arrow />
                                </Box>
                        </Box>
                      </Button>) : (
                         <Box sx={{display:'flex', flexDirection:'column', gap:'30px', py:2}}>
                            <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                            <Box 
                            sx={{alignItems:'center', alignSelf:'center'}}
                            component={'img'}
                            src={RejectedVerification}
                            height={'200px'}
                            width={'auto'}
                            />
                            <Typography variant='h5_1' sx={{ alignItems:'center', alignSelf:'center', fontSize:'25px', color: colors.secondary.navy, fontWeight:"600" }} >{statuses?.status == "final_rejection" ? 'KYC rejected' : 'KYC rejected, please submit again!'}</Typography>
                            <Typography sx={{ alignItems:'center', alignSelf:'center', fontSize:'12px', color:colors.text.secondary, maxWidth:"500px", textAlign:"center" }} >{moderationComment ? moderationComment : statuses?.status == "final_rejection" ? 'We could not verify your profile via Non-Doc method. Please use another method if possible or contact the Company where you try to verify your profile' : 'Your KYC has been rejected.'}</Typography>
                            </Box>
                        
                            {statuses?.status != "final_rejection" && <PrimaryButton onClick={() => setIsVerify(true)} sx={{fontWeight:"500", fontSize: '15px', display:"flex", alignSelf:"center"}} >
                            Resubmit
                            </PrimaryButton>}
                            <PrimaryButton onClick={() => setSumSubClicked(false)} sx={{fontWeight:"500", fontSize: '15px', display:"flex", alignSelf:"center"}} >
                            Back
                            </PrimaryButton>
                        </Box>
                      )}</> )
                        
                    )))
            )
        }

    </Box>

    )

}